import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';

export default function ContactButton({ isOutlined }) {
  return (
    <Link href="/about/contact">
      <Button
        color="primary"
        variant={isOutlined ? 'outlined' : 'contained'}
        className="mr-2"
      >
        <FontAwesomeIcon
          style={{ width: '22px', height: '22px' }}
          icon={faEnvelope}
          className="mr-2"
        />{' '}
        Contact us
      </Button>
    </Link>
  );
}
